<template>
    <div>
        <slot v-if="!isMobile || isVisible"></slot>
        <div v-if="isMobile && !isVisible" class="collapse-mobile__more">
            <span @click="show">Читать еще</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "CollapseMobile",
    data() {
        return {
            isVisible: false,
            isMobile: window.matchMedia('(min-width: 0px) and (max-width: 767px)').matches,
        }
    },
    methods: {
        show() {
            this.isVisible = true;
        },
    },
}
</script>

<style lang="scss">
@import "../../scss/base/include";

.collapse-mobile {
    &__more {
        font-size: 16px;
        line-height: 24px;
        color: $accent;

        span {
            cursor: pointer;
            border-bottom: 1px dashed $accent;
        }
    }
}
</style>
